<template>
    <section class="uses-tailwind @container">
        <div
            v-if="isLoading"
            class="flex justify-center"
        >
            <spinner :cover="false" />
        </div>
        <template v-if="!isLoading && entries.length">
            <production-progress-summary
                v-if="showTotalProgress"
                :progress="totalProgress"
                class="mb-8"
            />
            <div
                class="grid grid-cols-1 @2xl:grid-cols-2 gap-4 @5xl:grid-cols-3 @8xl:grid-cols-4 @12xl:grid-cols-5"
            >
                <production-progress-entry
                    v-for="entry in entries"
                    :key="entry.id"
                    :entry="entry"
                    :holidays="holidays"
                />
            </div>
        </template>
    </section>
</template>

<script>
// External dependencies
import moment from 'moment';
// APIs
import api from '../../api/productionProgress';
// Components
import ProductionProgressSummary from './ProductionProgressSummary';
import ProductionProgressEntry from './ProductionProgressEntry';
import Spinner from '../loader/Spinner';

export default {
    props: {
        dateString: {
            type: String,
            required: true,
        },
        workstationTypeIds: {
            type: Array,
            required: false,
        },
        showTotalProgress: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            totalProgress: 0,
            entries: [],
            isLoading: false,
            holidays: [],
        };
    },
    mounted() {
        this.fetchData();
    },
    computed: {
        date() {
            return moment(this.dateString);
        },
    },
    watch: {
        dateString() {
            this.fetchData();
        },
        workstationTypeIds() {
            this.fetchData();
        },
    },
    methods: {
        fetchData() {
            if (!this.date) {
                return;
            }

            this.isLoading = true;

            api.fetchProgressForWorkstationTypes(
                this.date,
                this.workstationTypeIds
            )
                .then((response) => {
                    const data = response.data.data;
                    this.totalProgress = data.totalProgress;
                    this.entries = data.entries;
                    this.holidays = data.holidays || [];
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
    components: {
        ProductionProgressSummary,
        ProductionProgressEntry,
        Spinner,
    },
};
</script>
